export const CARD_READER_TYPE = {
    TRICUBES_SDK: "Tricubes_SDK",
    WEBSOCKET: "Websocket"
}
